import React from 'react';
import { Row, Col, InputNumber, Input, Button, Space, Alert } from 'antd';
import { PlayCircleOutlined, EyeOutlined } from '@ant-design/icons';

interface ExecuteParamsProps {
  year: number;
  month: number;
  empFrom: string;
  empTo: string;
  loading: boolean;
  errors: string[];
  onYearChange: (v: number) => void;
  onMonthChange: (v: number) => void;
  onEmpFromChange: (v: string) => void;
  onEmpToChange: (v: string) => void;
  onExecute: () => void;
  onPreview: () => void;
}

const ExecuteParamsPanel: React.FC<ExecuteParamsProps> = ({
  year, month, empFrom, empTo, loading, errors,
  onYearChange, onMonthChange, onEmpFromChange, onEmpToChange,
  onExecute, onPreview,
}) => {
  return (
    <div style={{ marginBottom: 16 }}>
      <Row gutter={16} align="middle" style={{ marginBottom: 12 }}>
        <Col>
          <span style={{ marginRight: 8 }}>年度:</span>
          <InputNumber
            value={year}
            min={2000}
            max={2099}
            onChange={(v) => onYearChange(v ?? 2026)}
            style={{ width: 100 }}
            disabled={loading}
          />
        </Col>
        <Col>
          <span style={{ marginRight: 8 }}>月份:</span>
          <InputNumber
            value={month}
            min={1}
            max={12}
            onChange={(v) => onMonthChange(v ?? 1)}
            style={{ width: 80 }}
            disabled={loading}
          />
        </Col>
        <Col>
          <span style={{ marginRight: 8 }}>員工起始:</span>
          <Input
            value={empFrom}
            onChange={(e) => onEmpFromChange(e.target.value)}
            placeholder="空白=全部"
            style={{ width: 120 }}
            disabled={loading}
          />
        </Col>
        <Col>
          <span style={{ marginRight: 8 }}>員工結束:</span>
          <Input
            value={empTo}
            onChange={(e) => onEmpToChange(e.target.value)}
            placeholder="ZZZZZZZZ"
            style={{ width: 120 }}
            disabled={loading}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <Space>
            <Button
              type="primary"
              icon={<PlayCircleOutlined />}
              onClick={onExecute}
              loading={loading}
              danger
            >
              執行月結
            </Button>
            <Button
              icon={<EyeOutlined />}
              onClick={onPreview}
              loading={loading}
            >
              預覽
            </Button>
          </Space>
        </Col>
      </Row>
      {errors.length > 0 && (
        <div style={{ marginTop: 12 }}>
          {errors.map((err, i) => (
            <Alert key={i} message={err} type="error" showIcon style={{ marginBottom: 4 }} />
          ))}
        </div>
      )}
    </div>
  );
};

export default ExecuteParamsPanel;
